import { IChangeNameAction } from "./actions";
import { AppThunkAction } from "../typings";

const CHANGE_NAME = "CHANGE_NAME";

export const actions = {
    changeName: (name): AppThunkAction<IChangeNameAction> => {
        console.log(name);
        return (dispatch, getState) => {
            dispatch({ type: CHANGE_NAME, name });
        };
    },
};



// WEBPACK FOOTER //
// ./src/actions/name.actions.ts